import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api';
import { Card, Alert, Table } from 'flowbite-react';

export default function UserDetail() {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [views, setViews] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const data = await api.get(`/users/${userId}`);
        setUser(data.user);
        setViews(data.views || []);
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [userId]);

  if (error) return <Alert color="failure">{error}</Alert>;
  if (!user) return <Card><div>Загрузка...</div></Card>;

  return (
    <div className="grid gap-4">
      <Card>
        <h2 className="text-lg font-semibold">Пользователь #{user.id}</h2>
        <div className="grid md:grid-cols-2 gap-2 text-sm">
          <div>external_id: {user.external_id}</div>
          <div>name: {user.name}</div>
          <div>username: {user.username}</div>
          <div>created_at: {user.created_at}</div>
        </div>
      </Card>
      <Card>
        <h3 className="text-base font-semibold">Просмотры</h3>
        {/* Mobile cards */}
        <div className="grid gap-3 sm:hidden">
          {views.length === 0 ? (
            <div className="text-sm text-gray-500">Просмотры отсутствуют</div>
          ) : (
            views.map((v, i) => (
              <Card key={i}>
                <div className="text-sm">{v.property_title}</div>
                <div className="text-xs text-gray-500">{v.viewed_at}</div>
                <div className="text-xs text-gray-500">IP: {v.ip}</div>
              </Card>
            ))
          )}
        </div>
        {/* Desktop table */}
        <div className="overflow-x-auto hidden sm:block">
          <Table hoverable>
            <Table.Head>
              <Table.HeadCell>Когда</Table.HeadCell>
              <Table.HeadCell>Объект</Table.HeadCell>
              <Table.HeadCell>IP</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {views.map((v, i) => (
                <Table.Row key={i} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                  <Table.Cell>{v.viewed_at}</Table.Cell>
                  <Table.Cell>{v.property_title}</Table.Cell>
                  <Table.Cell>{v.ip}</Table.Cell>
                </Table.Row>
              ))}
              {views.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan={3} className="text-center text-sm text-gray-500">Просмотры отсутствуют</Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>
      </Card>
    </div>
  );
}